import { useApiClient } from "../apiClients";

export interface MissionZeroItemsResponse {
  grade_id: string;
  items: unknown[]; // JSONB libre — tableau d'items Mission Zéro
  version: number;
  updated_at: string;
}

const MISSION_ZERO_ENDPOINTS = {
  ITEMS: (gradeId: string) => `/v1/grades/${gradeId}/mission-zero/items`,
} as const;

export const useMissionZeroApi = () => {
  const apiClient = useApiClient("embed");

  const getMissionZeroItems = (gradeId: string) =>
    apiClient.get<MissionZeroItemsResponse>(MISSION_ZERO_ENDPOINTS.ITEMS(gradeId));

  // payload accepts either the legacy flat array or the new
  // { age_range, items[], scoring_notes } envelope — tc_embed_be stores it as-is (JSONB).
  const putMissionZeroItems = (gradeId: string, payload: unknown) =>
    apiClient.put<MissionZeroItemsResponse>(
      MISSION_ZERO_ENDPOINTS.ITEMS(gradeId),
      payload,
    );

  return { getMissionZeroItems, putMissionZeroItems };
};
